const DESKTOP_PLATFORMS = new Set([
  'tdesktop',
  'macos',
  'web',
  'weba',
  'unigram',
  'unknown',
])

export function isDesktopPlatform() {
  if (typeof window === 'undefined') return false
  const platform = String(window.Telegram?.WebApp?.platform || '').trim().toLowerCase()
  return DESKTOP_PLATFORMS.has(platform)
}

/** console.warn не удаляется esbuild pure — подходит для отладки на ПК */
export function debugLog(label, ...args) {
  if (!isDesktopPlatform()) return
  console.warn(`[WebApp:${label}]`, ...args.map(redactDebugValue))
}

const SENSITIVE_KEYS = /^(initdata|token|secret|password|authorization|signature)$/i

function redactDebugValue(value) {
  if (Array.isArray(value)) return value.map(redactDebugValue)
  if (!value || typeof value !== 'object') return value
  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => [
      key,
      SENSITIVE_KEYS.test(key) ? '[REDACTED]' : redactDebugValue(item),
    ]),
  )
}

export function installGlobalErrorHandlers() {
  if (typeof window === 'undefined') return

  window.onerror = (message, source, lineno, colno, error) => {
    console.error('[WebApp:global] window.onerror', {
      message,
      source,
      lineno,
      colno,
      error,
    })
    return false
  }

  window.onunhandledrejection = (event) => {
    console.error('[WebApp:global] unhandledrejection', event.reason)
  }
}
